import { forwardRef } from "react";
import { SearchCardProps } from "./types.ts";
import styles from "./ListContentResultCard.module.scss";
import ResultCountButton from "./ResultCountButton.tsx";
import BookDetails from "./BookDetails.tsx";
import ListResultCard from "../common/ListResultCard.tsx";

function ListContentResultCard(
  { searchResult, openPanel, libraryReturn, section }: SearchCardProps,
  ref: React.ForwardedRef<HTMLElement>
) {
  const asset = searchResult.asset;
  return (
    <ListResultCard
      asset={asset}
      coverWidth="56px"
      containerClassName={styles.wholeCard}
      ref={ref}
    >
      <div className={styles.listCardContent}>
        <div className={styles.listCardBookDetails}>
          <BookDetails asset={asset.manageAsset} showEdition showAuthor />
        </div>
        <div className={styles.listCardCountButton}>
          <ResultCountButton
            onClick={() => openPanel(searchResult.asset, section)}
            count={searchResult.count}
            title={asset.manageAsset.title}
            libraryReturn={libraryReturn}
          />
        </div>
      </div>
    </ListResultCard>
  );
}

const ResultCard = forwardRef<HTMLElement, SearchCardProps>(
  ListContentResultCard
);

export default ResultCard;
